import { Component } from '@angular/core';
import { ConfigService } from './_services/config.service';
import { ThemeService } from './_services/theme.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    title = 'District Website App';
    logs: any;

    constructor(
        private configService: ConfigService,
        private themeService: ThemeService 
    ) {
        this.configService.IsSystemActive();
        this.themeService.loadDarkTheme();


        const customElementsFilePaths = [
            // 'js/legislation-form/polyfills.js', // No need for polyfills since the main app already has the same polyfills
            // 'js/full-calendar-widget/polyfills.js',
            'js/legislation-form/main.js',
            'js/full-calendar-widget/main.js',
            'js/school-feed/main.js'
        ]

        // customElementsFilePaths.forEach(elementFilePath => {
        //     this.loadScript(this.configService.hostAddress + elementFilePath);
        // });

    }

    public loadScript(url: string) {
        const body = <HTMLDivElement> document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.src = url;
        script.async = false;
        script.defer = true;
        body.appendChild(script);
    }
}
